import { handleActions, createAction } from 'redux-actions';
import update from 'immutability-helper';
import mapActions from '@goodwaygroup/react-map-actions';

// Actions
export const actions = mapActions([
    'MOBILE_NAV_CLOSE',
    'MOBILE_NAV_TOGGLE'
], 'LAYOUT');


// Action Creators
export const closeMobileNav = createAction(actions.MOBILE_NAV_CLOSE);
export const toggleMobileNav = createAction(actions.MOBILE_NAV_TOGGLE);

// Reducers
const initialState = {
    mobileNavExpanded: false
};


export default handleActions({

    [actions.MOBILE_NAV_TOGGLE]: state => update(state, {
        mobileNavExpanded: { $set: !state.mobileNavExpanded }
    }),
    [actions.MOBILE_NAV_CLOSE]: state => update(state, {
        mobileNavExpanded: { $set: false }
    })

}, initialState);



// WEBPACK FOOTER //
// ./src/services/layout/duck.js